import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faTrash, faWarning, faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ReportService } from 'src/app/services/report.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { ForestTreament } from 'src/app/models/forestTreatment.model';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { MatAccordion } from '@angular/material/expansion';

@Component({
  selector: 'app-view-recommended-treatment',
  templateUrl: './view-recommended-treatment.component.html',
  styleUrls: ['./view-recommended-treatment.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class ViewRecommendedTreatmentComponent implements OnInit, AfterViewInit {

  faTrash = faTrash;
  faWarning = faWarning;
  faExternalLink = faExternalLink;
  faCircleXmark = faCircleXmark as IconProp;

  report = input.required<any>();
  @Output() loaded = new EventEmitter();
  forests: any[] = []
  treatments: any[][] = [];
  treatmentOptions: any;

  reg = APP_CONSTANTS.URL_REGEX;

  treatmentTypes: any[] = [];

  im = new Inputmask("currency", {
    groupSeparator: ',',
    prefix: '$',
    allowMinus: false
  });

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    this.initTreamentOptions()
  }

  ngOnInit(): void {
    this.reportService.getTreatmentOptions().subscribe((options: any) => {
      this.treatmentOptions = options
      this.forests = this.report().forests
      this.forests.forEach((forest: ReportForest) => {

        this.treatments.push([])

        forest.treatments?.forEach((treatment: ForestTreament) => {
          let option = this.findUnitOfMeasure(treatment);
          this.treatments[this.treatments.length - 1].push({
            treatment: treatment,
            specs: treatment.treatment_specifications,
            new: !treatment.from_GIS,
            forest_treatment_id: treatment.forest_treatment_id,
            specification_number: treatment.specification_number,
            treatment_option_id: treatment.treatment_option_id,
            option: option,
            // unit_of_measure: unit_of_measure
          })
        })
      })

      this.treatments.forEach((treatments: any) => { //per forest
        treatments.sort((a: any, b: any) => a.specification_number < b.specification_number ? -1 : 1)
        treatments.sort((a: any, b: any) => a.treatment_option_id < b.treatment_option_id ? -1 : 1)
      })
    });
  }

  ngAfterViewInit(): void {
    this.loaded.emit(5);
  }

  findUnitOfMeasure(treatment: any) {
    return this.treatmentOptions.find((option: any) => option.treatment_option_id == treatment.treatment_option_id)
  }

  treatmentTypeSelected(event: any, treatment: any) {
    treatment.type = event.value
  }

  standardTreatmentSelected(event: any, treatment: any) {
    treatment.standardTreatment = event.value
  }

  countGISTreatments(forestIndex: number) {
    let count = 0
    this.treatments[forestIndex].forEach((treatment: any) => {
      if (treatment.new == undefined) {
        count++;
      }
    })
    return count
  }

  countNewTreatments(forestIndex: number) {
    let count = 0
    this.treatments[forestIndex].forEach((treatment: any) => {
      if (treatment.new) {
        count++;
      }
    })
    return count
  }

  initTreamentOptions() {
    this.reportService.getTreatmentOptions().subscribe((response) => {
      this.treatmentTypes = []
      response.forEach((item: any) => {
        let existingTreatment = this.treatmentTypes.find((x: any) => x.type == item.treatment_type.treatment_type)
        if (existingTreatment) {
          existingTreatment.standardTreatments.push(item)
        } else {
          this.treatmentTypes.push({
            type: item.treatment_type.treatment_type,
            standardTreatments: [item],
            treatment_type_id: item.treatment_type_id,
            unit_of_measure: item.unit_of_measure,
          })
        }
      })
      this.updateTreatmentValues()
    })
  }

  updateTreatmentValues() {
    this.treatments.forEach((forest: any) => {
      forest.forEach((treatment: any) => {
        let treatmentType = this.treatmentTypes.find(
          (treatType: any) => treatType.treatment_type_id == treatment.treatment.treatment_type_id
        )
        if (treatmentType) {
          treatment.treatment.treatment_type = treatmentType.type

          let treatmentOption = treatmentType.standardTreatments.find(
            (item: any) => item.treatment_option_id == treatment.treatment.treatment_option_id
          )
          treatment.treatment.treatment_option = treatmentOption.treatment_option
        }
      })
    })
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  onTreatmentClick(event: MouseEvent, accordion: MatAccordion): void {
    if (event.ctrlKey) {
      if (accordion._stateChanges.closed) {
        accordion.openAll();
        accordion._stateChanges.closed = false;

      }
      else {
        accordion.closeAll();
        accordion._stateChanges.closed = true;
      }
    }
  }

  onTreatmentKeypress(event: any, accordion: MatAccordion): void {
    if (event.ctrlKey && event.key === "Enter") {
      if (accordion._stateChanges.closed) {
        accordion.openAll();
        accordion._stateChanges.closed = false;

      }
      else {
        accordion.closeAll();
        accordion._stateChanges.closed = true;
      }
    }
  }

  decodeURI(url: string): string {
    let decoded = decodeURI(url)
    if (decoded.includes('http')) return decoded;
    else return 'https://' + decoded;
  }
}
